import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { ErrorState, LoadingState } from "../components/ui";

/** Where managed login sends the browser back; completes the code exchange and returns to where the person was going. */
export function CallbackPage() {
  const { completeSignIn } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<unknown>();
  useEffect(() => {
    completeSignIn()
      .then((returnTo) => {
        // A full navigation, so the provider re-reads the session and /v1/me from scratch.
        window.location.replace(returnTo || "/");
      })
      .catch(setError);
  }, [completeSignIn, navigate]);
  if (error !== undefined) return <ErrorState title="Sign-in could not be completed." error={error} onRetry={() => window.location.assign("/login")} retryLabel="Try again" />;
  return <LoadingState label="Finishing sign-in…" />;
}
